import api from "./axios";

export const createOrganizer = async (payload) => {
  const response = await api.post("/companies", payload);
  return response.data;
};

export const getOrganizers = async (id = null, role = null) => {
  const params = {};
  if (id) params.id = id;
  if (role) params.role = role;
  const response = await api.get("/companies", { params });
  return response.data;
};
export const getAllOrganizers = async (
  parentId = null,
  role = null,
  params = {},
  config = {}
) => {
  const queryParams = { ...params };
  if (parentId) queryParams.id = parentId;
  if (role) queryParams.role = role;

  const response = await api.get("/companies/all-list", {
    params: queryParams,
    ...config,
  });
  return response.data;
};
export const getOrganizerById = async (id) => {
  const response = await api.get(`/companies/${id}`);
  return response.data;
};

export const updateOrganizer = async (id, payload) => {
  const response = await api.put(`/companies/${id}`, payload);
  return response.data;
};

export const deleteOrganizer = async (id) => {
  const response = await api.put(`/companies/delete/${id}`);
  return response.data;
};

export const getCompaniesDrobdown = async () => {
  const response = await api.get(`/companies/companiesDrobdown`);
  return response.data;
};
